// extracted by mini-css-extract-plugin
export default {"root":"OfferCardContent_root__5XkOk","header":"OfferCardContent_header__Tugst"};